<template>
  <div v-click-outside="closeOnOutsideClick ? clickOutside : ''"
       class="custom-select" :tabindex="tabindex" @blur="handleBlur">
    <div class="selected zt-hover font-medium transition-opacity"
         :class="{
          open: opened,
          '!text-center': center,
          'opacity-40': textShown === placeholder,
          smallSelected: selectedDivStyles,
         }"
         :style="selectedDivStyles"
         @click.stop="openOptions">
      <input v-if="editable"
             type="text"
             :value="textShown"
             @input="handleInput"
             class="no-default-style input-field pl-4 pr-8"
             :placeholder="placeholder"
             @focus="handleFocus"/>
      <div v-else>{{ textShown }}</div>
    </div>
    <div class="items" :class="{ hidden: !opened }" :style="optionsDivStyles">
      <div v-for="(option, index) of optionsToShow" :key="index"
           @click.stop="selectOption(option)">
        {{ option }}
      </div>
      <div v-if="showNoResultsInfo && !optionsToShow.length">
        Brak wyników
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      default: null,
    },
    tabindex: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    resetOnClick: {
      type: Boolean,
      default: true,
    },
    showNoResultsInfo: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      required: false,
      default(rawProps) {
        if (!rawProps.placeholder) {
          return { string: rawProps.default ?? rawProps.options[0] };
        } else {
          return { string: rawProps.default ?? '' };
        }
      },
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    optionsDivStyles: {
      type: Object,
      required: false,
    },
    selectedDivStyles: {
      type: Object,
      required: false,
    },
    closeOnSecondClick: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeOnOutsideClick: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      opened: false,
      clickOutside: {
        handler: (e) => {
          if (!e.target.closest('.tox')) {
            this.opened = false;
          }
        },
        events: ['touchend', 'mousedown'],
      },
    };
  },
  computed: {
    optionsToShow() {
      if (this.model.string === '') {
        return this.options;
      } else if (this.default && this.model.string === this.default) {
        return this.options;
      } else if (this.options.length > 0 && this.model.string === this.options[0]) {
        return this.options;
      } else if (this.editable) {
        let inputStringArr = this.model.string?.toLowerCase().replace(/\u00a0/g, " ").split(' ');
        return this.options.filter((option) =>
          inputStringArr?.every((inputString) =>
            option.toLowerCase().replace(/\u00a0/g, " ").includes(inputString)
          )
        );
      } else {
        return this.options;
      }
    },
    textShown() {
      if (this.placeholder) {
        return this.model.string === '' ? this.placeholder : this.model.string;
      } else {
        return this.model.string;
      }
    },
  },
  mounted() {
    this.$emit('input', this.model.string);
    if (this.default) {
      this.model.string = this.default;
    }
  },
  methods: {
    openOptions() {
      if (this.opened && this.closeOnSecondClick) {
        this.opened = false;
        return;
      }
      if (!this.disabled) {
        this.opened = true;
        if (this.opened && this.editable && (this.resetOnClick || this.model.string === this.default)) {
          this.model.string = '';
        }
      }
    },
    selectOption(option) {
      this.model.string = option;
      this.opened = false;
      this.$emit('input', option);
    },
    handleInput(e) {
      this.model.string = e.target.value;
    },
    handleFocus() {
      // Reakcja na focus, jeżeli jest to wymagane
    },
    handleBlur(e) {
      if (e.relatedTarget === this.$el) {
        return;
      }
      setTimeout(() => {
        this.opened = false;
        if (this.model.string === '') {
          this.model.string = this.default ? this.default : '';
        }
      }, 100);
    },
  },
};
</script>

<style scoped>
.custom-select {
  @apply px-0 leading-8 !important;
  @apply outline-none relative text-left;
}

.custom-select .selected {
  @apply h-[45px] pl-4 pr-8 pt-2 cursor-pointer select-none truncate;
}

.custom-select .selected.open {
  @apply border border-zt-light rounded-t-zt;
}

.custom-select .selected:after {
  @apply absolute top-5 right-4 w-0 h-0;
  content: "";
  border: 5px solid transparent;
  border-color: #fff transparent transparent transparent;
}

.custom-select .small-selected:after {
  @apply !top-[16px];
}

/* Ukrycie inputu, ale umożliwienie edycji */
.custom-select .input-field {
  @apply absolute top-0 left-0 w-full h-full bg-transparent border-none outline-none text-left cursor-pointer;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  text-align: inherit;
  visibility: visible; /* Zapewnia, że input jest widoczny */
  pointer-events: all; /* Pozwala na interakcję z inputem */
}

.custom-select .items {
  @apply absolute left-0 right-0 z-10 border-x border-b border-zt-light rounded-b-zt bg-zt-main max-h-[300px] overflow-y-auto;
  touch-action: manipulation; /* Zapewnia płynne przewijanie */
}

.custom-select .items div {
  @apply text-text pl-4 cursor-pointer select-none;
}

.custom-select .items div:hover {
  @apply bg-zt-light;
}
</style>
